module.exports = __webpack_public_path__ + "static/media/HLTC-USDT.7d41b882.svg";